// Tagalog: mobile tab bar, More sheet, page names, sign-in page and NFC button. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " and ": " at ",
  ".": " ng AssetOS.",
  "By signing in, you agree to AssetOS ": "Sa pag-sign in, sumasang-ayon ka sa ",
  "Terms of Service": "Mga Tuntunin ng Serbisyo",
  "Privacy Policy": "Patakaran sa Privacy",
  "API & Webhooks": "API at Webhooks",
  "Account Subscription & Plans": "Subscription at Mga Plano",
  "All {app} Modules": "Lahat ng Module ng {app}",
  "Allow NFC for this site to read tags.": "Payagan ang NFC sa site na ito para mabasa ang mga tag.",
  "Asset Custody & Movements": "Custody at Paglipat ng Asset",
  "Asset Disposals & Write-Offs": "Disposal at Write-Off ng Asset",
  "Asset Lookup": "Hanapin ang Asset",
  "Asset Quick View": "Mabilisang Tingin sa Asset",
  "Asset Valuation & Analytics Dashboard": "Dashboard ng Halaga at Analytics ng Asset",
  "Audit": "Audit",
  "Audit Reconciliation Console": "Audit Reconciliation Console",
  "Banquet Event Kits": "Mga Banquet Event Kit",
  "Banquet Event Kits & Batch Reconciliation": "Banquet Event Kit at Batch Reconciliation",
  "Blind Counts & Variance Console": "Blind Count at Variance Console",
  "Books": "Mga Libro",
  "Camera Scan HUD": "Scan gamit ang camera",
  "Catalogue": "Catalogue",
  "Connected Platforms": "Mga Nakakonektang Platform",
  "Contents": "Laman",
  "Corporate Email Address": "Corporate Email Address",
  "Demo": "Demo",
  "Demo accounts — 1-click test sign-in": "Mga demo account — 1-click na test sign-in",
  "Demo sign-in failed": "Hindi nagtagumpay ang demo sign-in",
  "Depreciation Runs & GL Schedules": "Depreciation Run at GL Schedule",
  "Email or password is incorrect": "Mali ang email o password",
  "Enter your work email first so we can find your organisation’s sign-in.": "Ilagay muna ang iyong work email para mahanap namin ang sign-in ng iyong organisasyon.",
  "Enterprise Hospitality Fixed Asset Operating System": "Enterprise na Sistema para sa Fixed Asset ng Hospitality",
  "Event Kits": "Mga Event Kit",
  "Exception Queue": "Pila ng Exception",
  "Exceptions": "Mga Exception",
  "Field App": "Field App",
  "First Scan": "Unang Scan",
  "First Scan Walk Binding": "First Scan Walk Binding",
  "First-Scan Walk": "First-Scan Walk",
  "Forgot Password": "Nakalimutan ang Password",
  "Forgot password?": "Nakalimutan ang password?",
  "Guest Loaners": "Mga Pahiram sa Bisita",
  "Guest Loaners & Overdue Tracker": "Pahiram sa Bisita at Tracker ng Overdue",
  "Hold the tag to the phone…": "Idikit ang tag sa telepono…",
  "How to get access": "Paano makakuha ng access",
  "IAS 16 cost model with USALI operating department allocation and automated Xero GL manual journals.": "IAS 16 cost model na may USALI allocation sa operating department at awtomatikong Xero GL manual journal.",
  "Inwarding & Asset Tagging": "Pagtanggap at Pag-tag ng Asset",
  "Integration Fabric Connectors": "Mga Integration Connector",
  "Linen Laundry": "Linen Laundry",
  "Loaners": "Mga Pahiram",
  "Maintenance Incident Logging": "Pag-log ng Insidente sa Maintenance",
  "Maintenance Incidents": "Mga Insidente sa Maintenance",
  "Maintenance incidents": "Mga insidente sa maintenance",
  "Maintenance incidents: {count} active": "Mga insidente sa maintenance: {count} aktibo",
  "Mobile App Navigation": "Navigation ng mobile app",
  "Mobile Physical Audits & Par Management": "Mobile na Pisikal na Audit at Par Management",
  "NFC is switched off or not available on this phone.": "Naka-off ang NFC o wala ito sa teleponong ito.",
  "Need an account? ": "Kailangan ng account? ",
  "OR": "O",
  "Offline": "Offline",
  "Offline-ready room audits, deterministic conflict resolution, and pooled inventory par replenishment.": "Room audit kahit offline, malinaw na pag-ayos ng conflict, at pag-replenish ng par ng pooled inventory.",
  "Offline: actions are saved on this device and synced later": "Offline: naka-save ang mga aksyon sa device na ito at isi-sync mamaya",
  "Opening Inventory": "Panimulang Imbentaryo",
  "Password": "Password",
  "Password is required": "Kailangan ang password",
  "Physical Audit Verification": "Pisikal na Audit Verification",
  "Please enter a valid corporate email address": "Maglagay ng tamang corporate email address",
  "Property & Location Registry": "Registry ng Property at Lokasyon",
  "Quick View": "Mabilisang Tingin",
  "Room Contents Sheet": "Listahan ng Laman ng Kuwarto",
  "Room Kit Templates & Stamping": "Mga Template ng Room Kit at Stamping",
  "Room Stamping & Opaque ULID Tags": "Room Stamping at Opaque ULID Tag",
  "Sign In": "Mag-sign In",
  "Sign In to Dashboard": "Mag-sign In sa Dashboard",
  "Sign in to manage hotel property fixed assets and operations": "Mag-sign in para pamahalaan ang fixed asset at operasyon ng hotel",
  "Sign in with your organisation": "Mag-sign in gamit ang iyong organisasyon",
  "Sign-in with your organisation did not complete. Please try again or use your email and password.": "Hindi natapos ang sign-in gamit ang iyong organisasyon. Subukang muli o gamitin ang email at password.",
  "Sign-in with your organisation was cancelled.": "Kinansela ang sign-in gamit ang iyong organisasyon.",
  "Single IFRS Book & USALI Allocations": "Iisang IFRS Book at USALI Allocation",
  "Single sign-on could not be started. Use your email and password.": "Hindi masimulan ang single sign-on. Gamitin ang email at password.",
  "Standardized room kit blueprints with tamper-evident QR codes and 6-character short codes.": "Standard na blueprint ng room kit na may tamper-evident na QR code at 6-character na short code.",
  "Stock": "Stock",
  "Stock & Par": "Stock at Par",
  "Stock Points & Par": "Mga Stock Point at Par",
  "Stock Points & Par Management": "Mga Stock Point at Par Management",
  "Streamlined property onboarding, room-level asset stamping, physical audit walks, native repair records, and automated single-book IAS 16 depreciation.": "Mas madaling onboarding ng property, asset stamping kada kuwarto, pisikal na audit walk, repair record, at awtomatikong IAS 16 depreciation sa iisang libro.",
  "Sync": "Sync",
  "Sync Status": "Status ng Sync",
  "Tag Generation & Binding": "Paggawa at Pag-bind ng Tag",
  "Tag Generation & Binding Console": "Console sa Paggawa at Pag-bind ng Tag",
  "Tag Studio": "Tag Studio",
  "Tap NFC tag": "I-tap ang NFC tag",
  "That sign-in attempt expired. Please try again.": "Nag-expire ang sign-in na iyon. Subukang muli.",
  "The tag could not be read. Hold the phone still against it and try again.": "Hindi mabasa ang tag. Huwag igalaw ang telepono habang nakadikit at subukang muli.",
  "There is no AssetOS account for this email. Ask your administrator for an invitation.": "Walang AssetOS account para sa email na ito. Humingi ng imbitasyon sa iyong administrator.",
  "This account belongs to a different organisation. Use your email and password instead.": "Ang account na ito ay sa ibang organisasyon. Gamitin na lang ang email at password.",
  "This invitation has already been used. Sign in with your organisation again.": "Nagamit na ang imbitasyong ito. Mag-sign in muli gamit ang iyong organisasyon.",
  "Toggle password visibility": "Ipakita/itago ang password",
  "User Registration": "Pagpaparehistro ng User",
  "Uses your organisation’s sign-in. Only people your administrator has invited can get in.": "Gumagamit ng sign-in ng iyong organisasyon. Ang mga inimbitahan lang ng administrator ang makakapasok.",
  "Welcome back": "Maligayang pagbabalik",
  "Work Orders & Repair Management": "Mga Work Order at Pamamahala ng Repair",
  "Your organisation has not verified this email address.": "Hindi pa na-verify ng iyong organisasyon ang email address na ito.",
  "Your organisation is not set up for single sign-on. Use your email and password.": "Hindi naka-set up ang iyong organisasyon para sa single sign-on. Gamitin ang email at password.",
  "field screens": "mga field screen",
  "{count} waiting to sync": "{count} naghihintay ma-sync",
};
